module.exports = __webpack_public_path__ + "static/media/YF16_1.4de644ec.jpg";